#import "../fragments/newsletter-stub-fragment.graphql"

query GetNewsletters(
    $limit: Int!
    $archived: Boolean!
    $cursor: String
    $sort: NewsletterSortType!
    $search: String
    $creatorUserId: String
    $lastUpdatedTime: String
    $statuses: [CampaignStatus!]
) {
    newsletters(
        first: $limit
        archived: $archived
        after: $cursor
        sort: $sort
        search: $search
        creatorUserId: $creatorUserId
        modifiedSinceTime: $lastUpdatedTime
        statuses: $statuses
    ) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...NewsletterStubFragment
            }
        }
    }
}
